module.exports = "<p class=row-item-more><a class=show-more tabindex=8.2 ng-click=toggleShowOptions() ng-class=\"{'active': showOptions, '': !showOptions}\">{{showOptions ? l10n.localize(\"Less search options\") : l10n.localize(\"More search options\")}}</a></p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base/templates/ukrail/form_options/toggle_additional_options.tmpl.html
// module id = 3710
// module chunks = 0